// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"MapTooltip_tooltip__HnaW4","noimage":"MapTooltip_noimage__Gexbl","description":"MapTooltip_description__1bN4n","title":"MapTooltip_title__1Vy8e"};